import styles from './AnnouncementsPage.module.css'

function AnnouncementsPage() {
  return (
    <div className={styles.announcementsPage}>
      <div className={styles.glassCard}>
        <h1>Duyurular</h1>
        <p>Toplu taşıma ile ilgili son duyuruları ve haberleri takip edin.</p>
      </div>
      
      <div className={styles.announcementsContainer}>
        {/* Duyuru listesi daha sonra eklenecek */}
      </div>
    </div>
  )
}

export default AnnouncementsPage
